import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/auth.service';
import { Router } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';

import { ForgotPasswordDialogComponent } from './forgot-password-dialog/forgot-password-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  error: string;

  constructor(
    public dialog:  MdDialog,
    private auth:   AuthService,
    private router: Router
  ) { }

  login(event, email: string, password: string) {
    console.log('logging in');
    event.preventDefault();
    this.auth.login(email, password).subscribe(
      data  => this.router.navigate(['home']),
      error => this.error = error
    );
  }

  openForgotPasswordDialog(): void {
    let dialogRef = this.dialog.open(ForgotPasswordDialogComponent, {
      width: '400px'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts